import { useCallback, useState } from 'react';
export var usePartialItemsLoad = function (itemsToLoadNum) {
    var _a = useState(itemsToLoadNum), itemsCount = _a[0], setItemsCount = _a[1];
    var loadItems = useCallback(function () {
        setItemsCount(function (val) { return val + itemsToLoadNum; });
    }, [itemsToLoadNum]);
    return {
        itemsCount: itemsCount,
        loadItems: loadItems,
    };
};
